import { createContext } from 'react';

export const BusinessCalendarContext = createContext({
  holidaysLookup: {},
  skipLookup: {},
  skipWeekdays: [],
});
